import { VuexModule, Module, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'
export interface PersionState {
    paneValue: number | null
  }
@Module({ dynamic: true, store, name: 'persion' })
class Persion extends VuexModule implements PersionState {
    public paneValue: number | null = null;
    public tableShow = false;
  @Mutation
    public SET_TABLESHOW (value: boolean) {
      this.tableShow = value
    }

  @Mutation
  public SET_PANEVALUE (_paneValue: number) {
    this.paneValue = _paneValue
  }
}

export const PersionModule = getModule(Persion)
